"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var mobx_react_1 = require("mobx-react");
var image_png_1 = __importDefault(require("images/estimate_reentry_modal/image.png"));
var EstimateFuyoReentryModal = /** @class */ (function (_super) {
    __extends(EstimateFuyoReentryModal, _super);
    function EstimateFuyoReentryModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EstimateFuyoReentryModal.prototype.render = function () {
        var store = this.props.store;
        return (react_1.default.createElement(react_responsive_modal_1.default, { open: store.isOpen, onClose: store.handleClose },
            react_1.default.createElement("div", { className: "coModalEstimateFuyoReentryModal-Container" },
                react_1.default.createElement("div", { className: "coModalEstimateFuyoReentryModal-Text" },
                    "\u7533\u8FBC\u3057\u305F\u5546\u54C1\u3092\u4E0D\u7528\u54C1\u3068\u3057\u3066",
                    react_1.default.createElement("br", null),
                    "\u56DE\u53CE\u3067\u304D\u308B\u696D\u8005\u304C\u898B\u3064\u304B\u308A\u307E\u3057\u305F\uFF01"),
                react_1.default.createElement("div", { className: "coModalEstimateFuyoReentryModal-Text-appeal" }, "\u4E0D\u7528\u54C1\u56DE\u53CE\u306E\u898B\u7A4D\u3082\u308A\u3092\u3057\u3066\u307F\u3088\u3046\uFF01"),
                react_1.default.createElement("img", { className: "coModalEstimateFuyoReentryModal-Image lazyload", src: image_png_1.default }),
                react_1.default.createElement("div", { className: "coModalEstimateFuyoReentryModal-Text-alert" }, "\u203B\u4E0D\u7528\u54C1\u3068\u3057\u3066\u306E\u56DE\u53CE\u306B\u306F\u6599\u91D1\u304C\u304B\u304B\u308A\u307E\u3059"),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("form", { action: store.endpoint, method: "post" },
                        react_1.default.createElement("input", { type: "hidden", name: "authenticity_token", value: store.authenticityToken }),
                        react_1.default.createElement("input", { type: "submit", value: "\u4E0D\u7528\u54C1\u56DE\u53CE\u306E\u898B\u7A4D\u3082\u308A\u3092\u3059\u308B", className: "sw-Button sw-Button-controlMain coModalEstimateFuyoReentryModal-SubmitButton" })),
                    react_1.default.createElement("button", { className: "sw-Button sw-Button-default coModalEstimateFuyoReentryModal-BackButton", onClick: store.handleClose }, "\u3082\u3069\u308B")))));
    };
    EstimateFuyoReentryModal = __decorate([
        mobx_react_1.observer
    ], EstimateFuyoReentryModal);
    return EstimateFuyoReentryModal;
}(react_1.default.Component));
exports.default = EstimateFuyoReentryModal;
